import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

import { edlinkIssuer } from './edlink.js';

export const userIdentityStatusSchema = z.enum(['active', 'inactive', 'registrable']);
export type UserIdentityStatus = z.infer<typeof userIdentityStatusSchema>;
export const UserIdentityStatus = userIdentityStatusSchema.enum;

const dateToInstant = z.instanceof(Date).transform((d) => Temporal.Instant.fromEpochMilliseconds(d.getTime()));

export const userIdentityLikeSchema = z.object({
  iss: z.string(),
  sub: z.string().nullable(),
  status: userIdentityStatusSchema,
});
export type UserIdentityLike = z.infer<typeof userIdentityLikeSchema>;

export const plainUserIdentitySchema = userIdentityLikeSchema.extend({
  id: z.string(),
});
export type PlainUserIdentity = z.infer<typeof plainUserIdentitySchema>;

export const userIdentitySchema = plainUserIdentitySchema.extend({
  userId: z.string(),
  createdAt: dateToInstant,
  updatedAt: dateToInstant,
});
export type UserIdentity = z.infer<typeof userIdentitySchema>;

export interface SSOExternalKeys {
  iss: string;
  sub: string;
}

export const GOOGLE_FIREBASE_PROVIDER_ID = 'google.com';
/** Set by Firebase on ID tokens issued via `signInWithCustomToken` (E2E test-auth). */
export const CUSTOM_FIREBASE_PROVIDER_ID = 'custom';

export const GOOGLE_SSO_ISS_PREFIX = 'https://securetoken.google.com/';

export function isGoogleSsoIss(iss: string): boolean {
  return iss.startsWith(GOOGLE_SSO_ISS_PREFIX);
}

export function findGoogleIdentity<U extends UserIdentityLike>(identities: U[]): U | undefined {
  return identities.find((identity) => isGoogleSsoIss(identity.iss));
}

export function findEdlinkIdentity<U extends UserIdentityLike>(identities: U[]): U | undefined {
  return identities.find((identity) => identity.iss === edlinkIssuer);
}
